// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3pdXL","detailsBorder":"styles_detailsBorder__3ykei"};